import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/ui/placeholder/jpg-png/cromi.png")